module.exports = __webpack_public_path__ + "img/3.cd80c4b2.jpg";